import BusinessQuery from './BusinessQuery'

export default BusinessQuery